(() => {
  const selectors = { cart: '[data-cart-drawer]', search: '[data-search-overlay]', toast: '[data-toast]' };
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];
  const getCart = () => fetch('/cart.js').then(response => response.json());
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: document.documentElement.dataset.currency || 'QAR' }).format(cents / 100);
  const announce = message => { const toast = $(selectors.toast); if (!toast) return; toast.textContent = message; toast.classList.add('is-visible'); window.setTimeout(() => toast.classList.remove('is-visible'), 3000); };
  const toggleLayer = (selector, show) => { const layer = $(selector); if (!layer) return; layer.classList.toggle('is-open', show); document.body.classList.toggle('overflow-hidden', show); if (show) $('[data-layer-close], input', layer)?.focus(); };
  const updateCartCount = cart => $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
  const cartMarkup = cart => {
    const items = cart.items.map(item => `<article class="cart-line"><a href="${item.url}"><img src="${item.featured_image?.url || ''}" alt="${item.featured_image?.alt || item.product_title}"></a><div><h3><a href="${item.url}">${item.product_title}</a></h3><p>${item.variant_title || ''}</p><form data-cart-line><input type="hidden" name="id" value="${item.key}"><div class="quantity"><button type="button" data-quantity-change="-1" aria-label="Decrease quantity">−</button><input name="quantity" value="${item.quantity}" min="0" type="number" aria-label="Quantity"><button type="button" data-quantity-change="1" aria-label="Increase quantity">+</button></div></form></div><div><strong>${money(item.final_line_price)}</strong><button class="text-button" data-cart-remove="${item.key}" type="button">×</button></div></article>`).join('');
    const threshold = Number(document.documentElement.dataset.shippingThreshold || 0) * 100;
    const remaining = Math.max(threshold - cart.total_price, 0);
    const progress = threshold ? Math.min(cart.total_price / threshold * 100, 100) : 100;
    return `<div class="cart-drawer__items">${cart.item_count ? items : `<div class="empty-state"><h1>Your bag is empty.</h1><a class="button button--secondary" href="/collections/all">Shop now</a></div>`}</div>${cart.item_count ? `<div class="cart-drawer__footer">${threshold ? `<p class="tax-note">${remaining ? `Spend ${money(remaining)} more for free shipping.` : 'You qualify for free shipping.'}</p><div class="shipping-progress"><span style="width:${progress}%"></span></div>` : ''}<dl><dt>Estimated total</dt><dd><strong>${money(cart.total_price)}</strong></dd></dl><div class="product-form__buttons"><a href="/cart/checkout" class="button button--cod">${document.documentElement.lang === 'ar' ? 'الدفع عند الاستلام' : 'Cash on Delivery'}</a><div id="paypal-drawer-buttons" class="paypal-buttons" data-paypal-amount-cents="${cart.total_price}"></div></div></div>` : ''}`;
  };
  const renderCart = cart => {
    const target = $('[data-cart-drawer-content]');
    if (target) target.innerHTML = cartMarkup(cart);
    updateCartCount(cart);
    if (cart.item_count && window.PayPalCheckout) window.PayPalCheckout.renderButtons('paypal-drawer-buttons', cart.total_price);
  };
  const refreshCart = () => getCart().then(renderCart);
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-cart-open]');
    if (opener) { event.preventDefault(); refreshCart().then(() => toggleLayer(selectors.cart, true)); }
    if (event.target.closest('[data-cart-close]')) toggleLayer(selectors.cart, false);
    const searchOpen = event.target.closest('[data-search-open]');
    if (searchOpen) { event.preventDefault(); toggleLayer(selectors.search, true); }
    if (event.target.closest('[data-search-close]')) toggleLayer(selectors.search, false);
    const filterToggle = event.target.closest('[data-filter-toggle]'); if (filterToggle) $('[data-filter-form]')?.classList.toggle('is-open');
    const announcementClose = event.target.closest('[data-announcement-close]'); if (announcementClose) { announcementClose.closest('.announcement')?.remove(); sessionStorage.setItem('auraAnnouncementDismissed','true'); }
    const qty = event.target.closest('[data-quantity-change]');
    if (qty) { const input = $('input[name="quantity"]', qty.closest('.quantity')); input.value = Math.max(0, Number(input.value) + Number(qty.dataset.quantityChange)); input.dispatchEvent(new Event('change', { bubbles: true })); }
    const remove = event.target.closest('[data-cart-remove]'); if (remove) fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ id:remove.dataset.cartRemove, quantity:0 }) }).then(refreshCart);
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('form[action^="/cart/add"]'); if (!form) return;
    event.preventDefault(); const button = $('[type="submit"]', form); button?.setAttribute('aria-busy','true');
    fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form) }).then(response => { if (!response.ok) throw new Error(); return response.json(); }).then(() => refreshCart()).then(() => { toggleLayer(selectors.cart, true); announce(document.documentElement.lang === 'ar' ? 'تمت الإضافة إلى السلة.' : 'Added to your bag.'); }).catch(() => announce(document.documentElement.lang === 'ar' ? 'حدث خطأ ما. يرجى المحاولة مرة أخرى.' : 'Something went wrong. Please try again.')).finally(() => button?.removeAttribute('aria-busy'));
  });
  document.addEventListener('change', event => {
    const line = event.target.closest('[data-cart-line]'); if (line) fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ id:$('input[name="id"]', line).value, quantity:$('input[name="quantity"]', line).value }) }).then(refreshCart);
  });
  const wishlist = { key:'aura-wishlist', get(){ try { return JSON.parse(localStorage.getItem(this.key) || '[]'); } catch { return []; } }, set(items){ localStorage.setItem(this.key, JSON.stringify(items)); this.paint(); }, toggle(handle){ const items = this.get(); this.set(items.includes(handle) ? items.filter(item => item !== handle) : [...items, handle]); }, paint(){ const items = this.get(); $$('[data-wishlist-toggle]').forEach(button => { const saved = items.includes(button.dataset.productHandle); button.classList.toggle('is-saved', saved); button.setAttribute('aria-pressed', saved); }); } };
  document.addEventListener('click', event => { const button = event.target.closest('[data-wishlist-toggle]'); if (button) { event.preventDefault(); wishlist.toggle(button.dataset.productHandle); announce(button.classList.contains('is-saved') ? (document.documentElement.lang === 'ar' ? 'تم الحفظ.' : 'Saved.') : (document.documentElement.lang === 'ar' ? 'تمت الإزالة من المحفوظات.' : 'Removed from saved.')); } });
  const predictive = $('[data-predictive-search]');
  if (predictive) { let controller; const results = $('[data-predictive-results]'); predictive.addEventListener('input', event => { const term = event.target.value.trim(); if (controller) controller.abort(); if (term.length < 2) { results.innerHTML=''; return; } controller = new AbortController(); fetch(`/search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=7&section_id=predictive-search`, { signal:controller.signal }).then(response => response.text()).then(html => { const doc = new DOMParser().parseFromString(html,'text/html'); results.innerHTML = $('[data-predictive-results]',doc)?.innerHTML || ''; }).catch(() => {}); }); }
  
  /* ---------------------------------------------------------------------
     Product gallery: vertical thumbnails, hover zoom (desktop), pinch/tap
     zoom lightbox (mobile), color-swatch sync.
  --------------------------------------------------------------------- */
  const galleryRoot = $('[data-product-gallery]');
  if (galleryRoot) {
    const stage = $('[data-gallery-stage]', galleryRoot);
    const thumbs = $$('[data-gallery-thumb]', galleryRoot);
    const slides = $$('[data-gallery-slide]', galleryRoot);
    const isFinePointer = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    const activateMedia = (root, mediaId) => {
      const scopedThumbs = $$('[data-gallery-thumb]', root);
      const scopedSlides = $$('[data-gallery-slide]', root);
      const id = String(mediaId);
      let matched = false;
      scopedSlides.forEach(slide => { const active = slide.dataset.mediaId === id; slide.classList.toggle('is-active', active); if (active) matched = true; });
      scopedThumbs.forEach(thumb => thumb.classList.toggle('is-active', thumb.dataset.mediaId === id));
      return matched;
    };
    window.AuraGallery = { activate: activateMedia };

    const setActiveThumb = thumb => { if (thumb) activateMedia(galleryRoot, thumb.dataset.mediaId); };
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => setActiveThumb(thumb));
      thumb.addEventListener('mouseenter', () => { if (isFinePointer()) setActiveThumb(thumb); });
    });

    // Desktop hover zoom on the active slide's image
    if (stage) {
      stage.addEventListener('mousemove', event => {
        if (!isFinePointer()) return;
        const activeImage = $('.product-gallery__slide.is-active .product-gallery__image', stage);
        if (!activeImage) return;
        const rect = stage.getBoundingClientRect();
        const x = Math.min(Math.max(((event.clientX - rect.left) / rect.width) * 100, 0), 100);
        const y = Math.min(Math.max(((event.clientY - rect.top) / rect.height) * 100, 0), 100);
        activeImage.style.transformOrigin = `${x}% ${y}%`;
      });
      stage.addEventListener('mouseenter', () => { if (isFinePointer()) stage.classList.add('is-zooming'); });
      stage.addEventListener('mouseleave', () => stage.classList.remove('is-zooming'));
    }

    // Lightbox with tap-to-open + pinch/double-tap zoom for touch devices
    const lightbox = $('[data-gallery-lightbox]');
    if (lightbox) {
      const lightboxImage = $('[data-lightbox-image]', lightbox);
      const lightboxStage = $('[data-lightbox-stage]', lightbox);
      let scale = 1, originX = 0, originY = 0, startDist = 0, startScale = 1;
      let isPanning = false, panLastX = 0, panLastY = 0, lastTapTime = 0;

      const applyTransform = () => { lightboxImage.style.transform = `translate(${originX}px, ${originY}px) scale(${scale})`; };
      const resetZoom = () => { scale = 1; originX = 0; originY = 0; applyTransform(); };
      const openLightbox = (src, alt) => {
        if (!src) return;
        lightboxImage.src = src;
        lightboxImage.alt = alt || '';
        resetZoom();
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
      };
      const closeLightbox = () => {
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
      };

      galleryRoot.addEventListener('click', event => {
        const trigger = event.target.closest('[data-gallery-open-lightbox]');
        if (!trigger) return;
        const img = $('img', trigger);
        if (img) openLightbox(img.currentSrc || img.src, img.alt);
      });
      $('[data-gallery-lightbox-close]', lightbox)?.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', event => { if (event.target === lightbox) closeLightbox(); });

      const distanceBetween = touches => Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);

      lightboxStage.addEventListener('touchstart', event => {
        if (event.touches.length === 2) { startDist = distanceBetween(event.touches); startScale = scale; isPanning = false; }
        else if (event.touches.length === 1 && scale > 1) { isPanning = true; panLastX = event.touches[0].clientX - originX; panLastY = event.touches[0].clientY - originY; }
      }, { passive: true });

      lightboxStage.addEventListener('touchmove', event => {
        if (event.touches.length === 2) {
          event.preventDefault();
          const dist = distanceBetween(event.touches);
          if (startDist) scale = Math.min(Math.max(startScale * (dist / startDist), 1), 4);
          applyTransform();
        } else if (event.touches.length === 1 && isPanning) {
          event.preventDefault();
          originX = event.touches[0].clientX - panLastX;
          originY = event.touches[0].clientY - panLastY;
          applyTransform();
        }
      }, { passive: false });

      lightboxStage.addEventListener('touchend', event => {
        if (event.touches.length < 2) startDist = 0;
        if (event.touches.length === 0) {
          isPanning = false;
          const now = Date.now();
          if (now - lastTapTime < 300) { scale = scale > 1 ? 1 : 2.4; originX = 0; originY = 0; applyTransform(); }
          lastTapTime = now;
        }
      });

      document.addEventListener('keydown', event => { if (event.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox(); });
    }
  }
  
  const productForm = $('form.product-form'); const productData = $('[data-product-json]');
  if (productForm && productData) {
    const variants = JSON.parse(productData.textContent);
    const variantInput = $('input[name="id"]', productForm); const submitButton = $('[type="submit"]', productForm);
    const quantityInput = $('input[name="quantity"]', productForm);
    const updatePaypalAmount = variant => {
      if (!variant || !window.PayPalCheckout) return;
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      window.PayPalCheckout.renderButtons('paypal-product-buttons', variant.price * quantity);
    };
    const updateVariant = () => {
      const selections = $$('fieldset', productForm).map(fieldset => $('input:checked', fieldset)?.value);
      const variant = selections.length ? variants.find(item => item.options.every((option, index) => option === selections[index])) : variants[0];
      if (!variant) return;
      variantInput.value = variant.id;
      if (submitButton) { submitButton.disabled = !variant.available; submitButton.textContent = variant.available ? (document.documentElement.lang === 'ar' ? 'أضف إلى السلة' : 'Add to Cart') : (document.documentElement.lang === 'ar' ? 'غير متوفر حاليًا' : 'Currently unavailable'); }
      $$('[data-selected-option]', productForm).forEach((element, index) => element.textContent = selections[index]);
      const priceWrap = $('[data-product-price]', productForm.closest('[data-product]'));
      if (priceWrap) {
        priceWrap.innerHTML = (variant.compare_at_price && variant.compare_at_price > variant.price)
          ? `<span class="price price--sale"><s>${money(variant.compare_at_price)}</s><strong>${money(variant.price)}</strong></span>`
          : `<span class="price">${money(variant.price)}</span>`;
      }
      
      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      if (mediaId && window.AuraGallery) {
        window.AuraGallery.activate(productForm.closest('[data-product]'), mediaId);
      }
      
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
      updatePaypalAmount(variant);
    };
    productForm.addEventListener('change', event => {
      if (event.target.matches('input[type="radio"]')) updateVariant();
      if (event.target.matches('input[name="quantity"]')) updatePaypalAmount(variants.find(item => item.id === Number(variantInput.value)) || variants[0]);
    });
    updatePaypalAmount(variants.find(item => item.id === Number(variantInput.value)) || variants[0]);
    const codButton = $('#cod-checkout-button', productForm);
    if (codButton) {
      codButton.addEventListener('click', () => {
        const isAr = document.documentElement.lang === 'ar';
        codButton.disabled = true;
        const originalText = codButton.textContent;
        codButton.textContent = isAr ? 'جارٍ التحويل…' : 'Redirecting…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantInput.value), quantity: Math.max(1, Number(quantityInput?.value || 1)) }),
        })
          .then(response => { if (!response.ok) throw new Error('add-to-cart failed'); window.location.href = '/checkout'; })
          .catch(() => {
            codButton.disabled = false;
            codButton.textContent = originalText;
            alert(isAr ? 'تعذر إتمام الطلب، حاول مرة أخرى.' : 'Could not proceed, please try again.');
          });
      });
    }
  }
  const wishlistGrid = $('[data-wishlist-grid]');
  if (wishlistGrid) {
    const empty = $('[data-wishlist-empty]'); const handles = wishlist.get();
    Promise.all(handles.map(handle => fetch(`/products/${encodeURIComponent(handle)}.js`).then(response => response.ok ? response.json() : null))).then(products => {
      const valid = products.filter(Boolean); if (!valid.length) return;
      empty.hidden = true;
      wishlistGrid.innerHTML = valid.map(product => `<article class="product-card"><div class="product-card__media"><a href="${product.url}"><img class="product-card__image" src="${product.featured_image || ''}" alt="${product.title}"></a><button class="wishlist-button is-saved" type="button" data-wishlist-toggle data-product-handle="${product.handle}" aria-label="Save" aria-pressed="true">♡</button></div><div class="product-card__details"><h3><a href="${product.url}">${product.title}</a></h3><span class="price">${money(product.price)}</span></div></article>`).join('');
    }).catch(() => {});
  }
  $$('[data-mobile-nav-open]').forEach(button => button.addEventListener('click', () => toggleLayer('[data-mobile-navigation]', true)));
  $$('[data-mobile-nav-close]').forEach(button => button.addEventListener('click', () => toggleLayer('[data-mobile-navigation]', false)));
  if (sessionStorage.getItem('auraAnnouncementDismissed') === 'true') $('.announcement')?.remove();
  wishlist.paint(); refreshCart();
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { toggleLayer(selectors.cart,false); toggleLayer(selectors.search,false); } });
})();